var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_2570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57967 0.375 0.375 5.57967 0.375 12C0.375 18.4203 5.57967 23.625 12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57967 18.4203 0.375 12 0.375ZM12 21.375C6.81881 21.375 2.625 17.182 2.625 12C2.625 6.81886 6.81802 2.625 12 2.625C17.1812 2.625 21.375 6.81802 21.375 12C21.375 17.1812 17.182 21.375 12 21.375ZM17.0321 16.6376C16.5814 17.0929 14.8979 18.5781 12.154 18.5781C8.29013 18.5781 5.56884 15.6988 5.56884 11.9421C5.56884 8.23186 8.39423 5.40769 12.1202 5.40769C14.7232 5.40769 16.2798 6.6555 16.6949 7.03795C16.7924 7.12766 16.855 7.24899 16.8716 7.38046C16.8882 7.51193 16.8578 7.64503 16.7856 7.75617L15.9346 9.07397C15.7545 9.35288 15.3737 9.41531 15.1143 9.21089C14.7114 8.89327 13.623 8.15442 12.2218 8.15442C9.95756 8.15442 8.56945 9.81052 8.56945 11.9083C8.56945 13.8577 9.82983 15.8313 12.2387 15.8313C13.7695 15.8313 14.9032 14.9389 15.3196 14.5552C15.5666 14.3275 15.9569 14.3658 16.1549 14.6366L17.0861 15.9102C17.1655 16.0179 17.2036 16.1505 17.1937 16.2839C17.1838 16.4173 17.1265 16.5428 17.0321 16.6376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_2570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.9fc944525b884cc2a96688dd572ea2ce.svg";
export { ForwardRef as ReactComponent };